import {ChangeDetectionStrategy, Component} from "@angular/core";
import {FUIAbstractFascia} from "../../abstract-fascia";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-pop-fascia",
    styleUrls: ["./pop-fascia.component.scss"],
    templateUrl: "./pop-fascia.component.html",
    standalone: false
})
export class FUIPopFasciaComponent extends FUIAbstractFascia {
}
